import type { FC } from "react";

import {
  POLAROID_IMAGE_DEFAULTS,
  type TPolaroidImageProps,
} from "@/ui/components/primitives/PolaroidImage/PolaroidImage.config";
import { Container } from "@/ui/components/layout/Container";
import { AspectRatio } from "@/ui/components/primitives/AspectRatio";
import { Image } from "@/ui/components/primitives/Image";
import { cn } from "@/ui/lib/utils";

export const PolaroidImage: FC<TPolaroidImageProps> = ({
  image,
  rotation = POLAROID_IMAGE_DEFAULTS.rotation,
  className,
  ...props
}) => (
  <Container
    {...props}
    data-component="PolaroidImage"
    className={cn(
      "w-36 h-40 border border-sys-grey-500 bg-sys-white p-3 shadow-lg",
      className,
    )}
    style={{ transform: `rotate(${rotation}deg)` }}
  >
    <AspectRatio ratio="1:1">
      <Image {...image} fit="cover" />
    </AspectRatio>
  </Container>
);

PolaroidImage.displayName = "PolaroidImage";
